// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ProjectFulfillmentBySkuRow } from '@/project/api/types';

/**
 * Computes the outstanding "need" for a SKU on a fulfillment order, given the
 * project fulfillment summary row for that SKU and this FO's own contribution
 * to the project's `foRequested` total (zero in create mode; the saved
 * requestedQuantity in edit mode).
 *
 *   fulfilled = max(0, summary.foRequested - own)   // coverage from other FOs
 *   need      = max(0, summary.projectRequested - fulfilled)
 *
 * The two clamps matter independently: clamping `fulfilled` first prevents a
 * concurrent-edit race (where summary is briefly stale and own > foRequested)
 * from inflating need above projectRequested. Both display math (the items
 * table) and the auto-default for the Quantity input share this helper so
 * they can never diverge.
 */
export function computeFulfillmentNeed(
  summary: ProjectFulfillmentBySkuRow,
  own: number
): { fulfilled: number; need: number } {
  const fulfilled = Math.max(0, summary.foRequested - own);
  const need = Math.max(0, summary.projectRequested - fulfilled);
  return { fulfilled, need };
}
